import { createAction } from '@reduxjs/toolkit'

export const SET_CONSENT_RESOLVED_STATE = 'consent/resolvedState/set'

export const setConsentResolvedState = createAction(SET_CONSENT_RESOLVED_STATE)
